import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mb-0 mt-2 text-sm leading-tight text-gray-500" }
const _hoisted_2 = { class: "grid grid-cols-[minmax(0,1fr)_72px_92px] items-end gap-3 border-b-2 border-gray-400 pb-2 text-sm sm:grid-cols-[minmax(0,1fr)_96px_112px] sm:gap-4" }
const _hoisted_3 = { class: "text-right" }
const _hoisted_4 = { class: "text-xs text-black" }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = { class: "text-xs text-black" }
const _hoisted_7 = {
  key: 0,
  class: "space-y-4 py-6"
}
const _hoisted_8 = {
  key: 1,
  class: "py-10 text-center text-sm text-gray-500"
}
const _hoisted_9 = {
  key: 2,
  class: "divide-y divide-gray-100"
}
const _hoisted_10 = { class: "grid grid-cols-[minmax(0,1fr)_72px_92px] items-center gap-3 sm:grid-cols-[minmax(0,1fr)_96px_112px] sm:gap-4" }
const _hoisted_11 = { class: "min-w-0 flex items-center gap-3" }
const _hoisted_12 = { class: "h-9 w-9 shrink-0 overflow-hidden rounded bg-gray-100 ring-1 ring-gray-200" }
const _hoisted_13 = ["src", "alt", "onError"]
const _hoisted_14 = {
  key: 1,
  class: "flex h-full w-full items-center justify-center text-xs font-semibold text-gray-500"
}
const _hoisted_15 = { class: "min-w-0" }
const _hoisted_16 = { class: "truncate text-sm font-medium text-black" }
const _hoisted_17 = {
  key: 0,
  class: "truncate text-xs text-gray-500"
}
const _hoisted_18 = { class: "text-right text-sm font-medium text-black" }
const _hoisted_19 = { class: "text-right text-sm font-medium text-black" }
const _hoisted_20 = { class: "mt-3 h-1.5 overflow-hidden rounded-full bg-gray-100" }

import { computed, reactive } from 'vue'
import type { ProduitRow } from '@/types'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductSalesStatsSection',
  props: {
    rows: { default: () => [] },
    loading: { type: Boolean, default: false },
    periodLabel: {},
    frameless: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const failedImages = reactive<Record<number, boolean>>({})

const totalQuantity = computed(() =>
  props.rows.reduce((total, row) => total + Number(row.ventes || 0), 0),
)

const totalAmount = computed(() =>
  props.rows.reduce((total, row) => {
    if (typeof row.chiffreAffaires === 'number') {
      return total + row.chiffreAffaires
    }
    const normalized = String(row.chiffreAffaires || '0')
      .replace(/\s/g, '')
      .replace('€', '')
      .replace(',', '.')
    return total + (Number.parseFloat(normalized) || 0)
  }, 0),
)

const maxQuantity = computed(() =>
  Math.max(1, ...props.rows.map((row) => Number(row.ventes || 0))),
)

const formatCurrency = (value: number) =>
  `${value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`

const getWidth = (quantity: number) =>
  Math.max(3, Math.round((Number(quantity || 0) / maxQuantity.value) * 100))

const getInitial = (reference: string) =>
  (reference || '?').trim().charAt(0).toUpperCase() || '?'

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass([
      props.frameless
        ? 'bg-transparent overflow-hidden'
        : 'bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden'
    ])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(props.frameless ? 'pt-1 pb-2' : 'px-6 pt-5 pb-4 border-b border-gray-200')
    }, [
      _createElementVNode("div", null, [
        _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "mb-0 text-xl font-semibold leading-tight text-black" }, " Quantité de produits vendus (pièces) ", -1)),
        _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.periodLabel), 1)
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(props.frameless ? 'pt-3 pb-5' : 'px-6 py-5')
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "font-medium text-black" }, "Produits", -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "font-medium text-black" }, "Qté (pcs)", -1)),
          _createElementVNode("div", _hoisted_4, _toDisplayString(totalQuantity.value), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "font-medium text-black" }, "Montant (HT)", -1)),
          _createElementVNode("div", _hoisted_6, _toDisplayString(formatCurrency(totalAmount.value)), 1)
        ])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
              return _createElementVNode("div", {
                key: index,
                class: "animate-pulse"
              }, _cache[4] || (_cache[4] = [
                _createStaticVNode("<div class=\"grid grid-cols-[minmax(0,1fr)_72px_92px] items-center gap-3 sm:grid-cols-[minmax(0,1fr)_96px_112px] sm:gap-4\"><div class=\"flex items-center gap-3\"><div class=\"h-9 w-9 rounded bg-gray-200\"></div><div class=\"h-3 w-2/3 rounded bg-gray-200\"></div></div><div class=\"ml-auto h-3 w-10 rounded bg-gray-200\"></div><div class=\"ml-auto h-3 w-16 rounded bg-gray-200\"></div></div><div class=\"mt-3 h-1 rounded bg-gray-100\"></div>", 2)
              ]))
            }), 64))
          ]))
        : (_ctx.rows.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Aucune vente sur cette période. "))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: row.id,
                  class: "py-4"
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        (row.imageUrl && !failedImages[row.id])
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: row.imageUrl,
                              alt: row.reference,
                              class: "h-full w-full object-cover",
                              onError: ($event: any) => (failedImages[row.id] = true)
                            }, null, 40, _hoisted_13))
                          : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(getInitial(row.reference)), 1))
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(row.reference), 1),
                        (row.categorie)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(row.categorie), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(row.ventes), 1),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(row.chiffreAffaires), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", {
                      class: "h-full rounded-full bg-blue-700",
                      style: _normalizeStyle({ width: `${getWidth(row.ventes)}%` })
                    }, null, 4)
                  ])
                ]))
              }), 128))
            ]))
    ], 2)
  ], 2))
}
}

})